import './NonStandardLevelNsCard.css';

import { useLoginContext } from '../../../../App';
import { fullImagePath } from '../../../b2b-common/helpers';
import { getParentLevelNsIds } from '../../../b2b-frameworks/components/helper';
import useLevelNImagePathWithAPIKey from '../../../b2b-frameworks/hooks/useLevelNImagePathWithAPIKey';
import { Card, CardMedia } from '@mui/material';

const NonStandardLevelNsCard = ({ frameworkSuite, frameworkId, nonStandardLevelN, selectedNonStandardLevelNs, onClick }) => {
    const { loginData } = useLoginContext();

    const parentLevelNsIds = getParentLevelNsIds(nonStandardLevelN.levelN_ItemId);
    const topParent = parentLevelNsIds[0];
    const imagePath = useLevelNImagePathWithAPIKey(frameworkSuite, frameworkId, topParent, loginData.locale);

    const isSelected = selectedNonStandardLevelNs?.findIndex
        (item => item.levelN_ItemId === nonStandardLevelN.levelN_ItemId && item.frameworkId === nonStandardLevelN.frameworkId) >= 0;

    return (
        <Card variant='outlined' 
            className='non-standard-level-ns-card'
            onClick={() => onClick(nonStandardLevelN)}
        >
            <CardMedia
                component='img'
                height='100%'
                image={fullImagePath(imagePath)}
                title={nonStandardLevelN.levelN_ItemName}
                alt={parentLevelNsIds[0]}
                className={isSelected ? 'selected' : 'not-selected'}
            />
        </Card>
    );
}

export default NonStandardLevelNsCard;